import axios from 'axios'
import errorHandler from '../../errorHandler'
import errorHandlerAdmin from '../../errorHandlerAdmin'

const authEndpoints = ['/api/otp', '/api/login']

const isAuthEndpoint = url => authEndpoints.some(endpoint =>
  url === endpoint || url?.startsWith(`${endpoint}?`) || url?.endsWith(endpoint)
)

const ApiPlugin = (Vue) => {
  const instance = axios.create({
	baseURL:	process.env.VUE_APP_baseURL
  });
  console.log(instance.baseURL);
  instance.interceptors.request.use(config =>  {

    config.headers["Content-Type"] = 'application/json'

    const token = window.localStorage.getItem('jwt')

    if (isAuthEndpoint(config.url)) {
      delete config.headers['Authorization']
      delete config.headers['authorization']
    } else if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
      config.authTokenAtRequest = token
    }

    return config
  });

  const adminInstance = axios.create({
	baseURL:	process.env.VUE_APP_baseURL
  })

  adminInstance.interceptors.request.use(config => {

    config.headers["Content-Type"] = 'application/json'

    const tokenAdmin = window.localStorage.getItem('jwt-admin')

    if (tokenAdmin) config.headers['Authorization'] = `Bearer ${tokenAdmin}`

    return config
  });

  instance.interceptors.response.use(null, errorHandler);
  adminInstance.interceptors.response.use(null, errorHandlerAdmin);

  Vue.prototype.$http = Vue.http = instance
  Vue.prototype.$http_admin = Vue.http_admin = adminInstance
};

export default {install: ApiPlugin}
